import React from 'react'
import { DefaultLayout } from '../../layouts'
import { PageDataFetcher, PageHeader } from '../../components'
import { PageContent } from './components'
import { fetchOrganizations as fetcher, setQuery } from '../../features/organizations/slice'
import { useInternationalization } from '../../features/i18n/hook'
import * as pageConfig from './config'
import AudienceListener from '../../features/collection/components/audience-listener'
const { PAGE_IMAGE, STATE_KEY } = pageConfig

const Organization = (props) => {
  const { translate } = useInternationalization()

  return (
    <DefaultLayout>
      <AudienceListener />
      <PageDataFetcher
        stateKey={STATE_KEY}
        fetcher={fetcher}
        querySetter={setQuery}
        pageConfig={pageConfig}
        {...props}
      >
        <PageHeader
          title={translate('ORGANIZATION', 'plural')}
          description={translate('ORGANIZATION', 'page_description')}
          image={PAGE_IMAGE}
          className="lg:py-4"
        />
        <PageContent />
      </PageDataFetcher>
    </DefaultLayout>
  )
}

export { Organization }
